import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  CircularProgress,
  Typography,
  FormControl,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import styles from "./InviteDialog.module.css";
import {
  defaultInviteOption,
  upgradeStoredOption,
} from "../../utils/sectionPermissions";

const EditInviteDialog = ({
  editInviteUserCloseHandler,
  editInfo,
  trigger,
  setTrigger,
  showEditInviteDialog,
  setShowEditInviteDialog,
}) => {
  // Section-based permissions. Members carry an `option` array on their
  // adminUser row; upgradeStoredOption() projects any old per-route
  // entries (allworkspace, alluser, …) onto the new five sections so
  // pre-existing invites still render correctly here.
  const formInitialState = {
    email: editInfo?.email,
    role: editInfo?.role,
    option:
      editInfo?.role === "member"
        ? upgradeStoredOption(editInfo?.option)
        : defaultInviteOption(),
  };
  const [formData, setFormData] = useState(formInitialState);
  const [postLoader, setPostLoader] = useState(false);
  console.log("editInfo", editInfo);
  console.log("formData", formData);
  const handleRoleChange = (e) => {
    setFormData({ ...formData, role: e.target.value });
  };
  const handleOptionRoleChange = (i, val) => {
    let temp = [...formData.option];
    temp[i] = { ...temp[i], role: val };
    if (val !== "allow" && Array.isArray(temp[i].items)) {
      temp[i].items = temp[i].items.map((it) => ({ ...it, role: "noallow" }));
    }
    setFormData({ ...formData, option: temp });
  };

  const handleItemRoleChange = (sectionIdx, itemIdx, val) => {
    let temp = [...formData.option];
    const section = { ...temp[sectionIdx] };
    if (!Array.isArray(section.items)) return;
    section.items = section.items.map((it, j) =>
      j === itemIdx ? { ...it, role: val } : it,
    );
    if (val === "allow" && section.role !== "allow") {
      section.role = "allow";
    }
    temp[sectionIdx] = section;
    setFormData({ ...formData, option: temp });
  };

  const handleSubmit = () => {
    setPostLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/update_invite_workspace`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify(formData),
    }).then(() => {
      setTrigger(!trigger);
      setFormData(formInitialState);
      setShowEditInviteDialog(false);
      setPostLoader(false);
    });
  };
  console.log("formData", formData);
  
  return (
    <Dialog
      open={showEditInviteDialog}
      onClose={editInviteUserCloseHandler}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Edit Invite</DialogTitle>
      <DialogContent>
        <Typography fontWeight={600} mb={2}>
          Change Role for {formData.email}
        </Typography>
        <FormControl fullWidth>
          <Select value={formData.role} onChange={handleRoleChange}>
            <MenuItem value="admin">Admin</MenuItem>
            <MenuItem value="member">Member</MenuItem>
          </Select>
        </FormControl>
        {formData.role === "member" && (
          <Box mt={2}>
            {formData.option.map((op, i) => (
              <Box
                key={i}
                sx={{
                  mb: 1.5,
                  p: 1.5,
                  borderRadius: 1,
                  border: "1px solid #e6eef6",
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={7}>
                    <Typography fontWeight="bold">{op.Title}</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <FormControl fullWidth size="small">
                      <Select
                        value={op.role}
                        onChange={(e) =>
                          handleOptionRoleChange(i, e.target.value)
                        }
                      >
                        <MenuItem value="allow">Allow</MenuItem>
                        <MenuItem value="noallow">Not Allow</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                {Array.isArray(op.items) && op.items.length > 0 && (
                  <Box
                    sx={{
                      mt: 1.5,
                      pl: 2,
                      borderLeft: "2px solid #e6eef6",
                      opacity: op.role === "allow" ? 1 : 0.55,
                    }}
                  >
                    {op.items.map((it, j) => (
                      <Grid
                        container
                        spacing={1}
                        alignItems="center"
                        key={it.to}
                        sx={{ py: 0.5 }}
                      >
                        <Grid item xs={7}>
                          <Typography
                            fontSize={13.5}
                            color={op.role === "allow" ? "text.primary" : "text.secondary"}
                          >
                            {it.label}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <FormControl fullWidth size="small">
                            <Select
                              value={it.role}
                              onChange={(e) =>
                                handleItemRoleChange(i, j, e.target.value)
                              }
                              disabled={op.role !== "allow"}
                            >
                              <MenuItem value="allow">Allow</MenuItem>
                              <MenuItem value="noallow">Not Allow</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    ))}
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSubmit}
          disabled={postLoader}
          className={styles.actionButton}
        >
          {postLoader ? <CircularProgress size={24} /> : "Update"}
        </Button>
        <Button
          onClick={editInviteUserCloseHandler}
          className={styles.closeButton}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditInviteDialog;
